import axios from 'axios';
import retryQuery from './RetryQuery';

const submitContactForm = (contactBody) =>
  retryQuery(() =>
    axios.post(`${process.env.REACT_APP_API_URL}/contact`, contactBody ?? {})
  );

export default submitContactForm;
